import React from "react";
import { motion } from "framer-motion";
import "../styles/PublicWork.css";

const groups = [
  {
    label: "AMAs",
    items: [
      {
        date: "18 Sep 2026",
        title: "Safer Agentic Workflows with ACN",
        detail: "Concordium",
        href: "https://x.com/i/spaces/1RJZzBnpmDAJB",
      },
      {
        date: "27 Apr 2026",
        title: "AITECH to ACN Migration",
        detail: "HTX",
        href: "https://twitter.com/i/spaces/1dJrPEYlAkQKX",
      },
      {
        date: "23 Apr 2026",
        title: "Powering AI for Everyone",
        detail: "HTX",
        href: "https://x.com/i/spaces/1yxBeMbBqkYJN?s=20",
      },
      {
        date: "26 Jun 2025",
        title: "Solidus AI Tech",
        detail: "Uphold",
        href: "https://x.com/i/spaces/1YqKDZnZPQQJV?s=20",
      },
      {
        date: "18 Sep 2025",
        title: "Hooked",
        href: "https://x.com/i/spaces/1lPKqvgzObbGb",
      },
      {
        date: "15 Apr 2025",
        title: "Agent Forge, live",
        detail: "BSC Daily",
        href: "https://x.com/i/broadcasts/1gqGvjMwmbgGB",
      },
    ],
  },
  {
    label: "Hackathons",
    items: [
      {
        date: "2025",
        title: "BNB AI Hack",
        detail: "Judge · BNB Chain online edition, 12 Feb–31 Dec",
        href: "https://www.bnbchain.org/en/hackathons/bnb-ai-hack",
      },
      {
        date: "2024",
        title: "Solidus AI Tech Hack-AI-Thon",
        detail: "Judge · Layer 2 · 16 Sep–17 Nov",
        href: "https://solidus-layer2.hackerearth.com/community/challenges/hackathon/solidus-ai-tech-hack-ai-thon/",
      },
    ],
  },
  {
    label: "Press",
    items: [
      {
        date: "Sep 2026",
        title: "A Human Behind Every Agent: Concordium Identity Comes to Agent Forge",
        detail: "Concordium",
        href: "https://www.concordium.com/article/a-human-behind-every-agent-concordium-identity-comes-to-agent-forge",
      },
      {
        date: "Aug 2026",
        title:
          "AITECH Cloud Network and Secret Network Partner to Bring Confidential AI to Agent Forge",
        detail: "Yahoo Finance",
        href: "https://finance.yahoo.com/technology/ai/articles/aitech-cloud-network-secret-network-181100795.html",
      },
      {
        date: "Jul 2025",
        title:
          "Solidus AI Tech and Secret Network Partner to Deploy Confidential AI Tools",
        detail: "Yahoo Finance",
        href: "https://finance.yahoo.com/news/solidus-ai-tech-secret-network-210100972.html",
      },
    ],
  },
  {
    label: "Publications",
    items: [
      {
        date: "Mar 2024",
        title:
          "Spontaneous Macro and Micro Facial Expression Recognition Using ResNet50 and VLDSP",
        detail: "Springer",
        href: "https://link.springer.com/chapter/10.1007/978-981-99-8324-7_15",
      },
    ],
  },
];

const container = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.06,
    },
  },
};

const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.55,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const Arrow = () => (
  <svg className="public-arrow" viewBox="0 0 16 16" aria-hidden="true">
    <path
      d="M4.5 11.5 L11.5 4.5 M6.5 4.5 H11.5 V9.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PublicWork = () => {
  return (
    <section id="public" className="public-section">
      <motion.div
        className="public-inner"
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
      >
        <motion.header className="public-header" variants={fadeUp}>
          <p className="public-kicker">In public</p>
          <p className="public-lead">
            Live rooms, a Binance hackathon I judged, and the writeups that
            put the work on record.
          </p>
        </motion.header>

        {groups.map((group) => (
          <motion.div key={group.label} className="public-group" variants={fadeUp}>
            <p className="public-group-label">{group.label}</p>
            <ul className="public-list">
              {group.items.map((item) => (
                <li key={item.href}>
                  <a
                    className="public-row"
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="public-date">{item.date}</span>
                    <span className="public-copy">
                      <span className="public-title">{item.title}</span>
                      {item.detail && (
                        <span className="public-detail">{item.detail}</span>
                      )}
                    </span>
                    <Arrow />
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default PublicWork;
